import { Link } from "react-router-dom"
import { GmailCard } from "@/components/gmail"
import { SettingsTitle } from "./settings-general"

/**
 * Settings → Customer messages: where admin → Messages gets its conversations. Contact-form messages
 * always come in; the support mailbox (Gmail) adds the emails customers send to it.
 */
export function InboxSettingsPage() {
  return (
    <div className="flex flex-col gap-4 pb-24">
      <SettingsTitle title="Customer messages" subtitle="Contact-form messages and emails to the support mailbox, in Messages." />
      <GmailCard />
      <p className="text-[12px] text-[var(--k-ink-muted)]">
        Conversations are worked in <Link to="/messages" className="text-[var(--k-blue)] hover:underline">Messages</Link>. Every email the store sends is listed in{" "}
        <Link to="/settings/messages" className="text-[var(--k-blue)] hover:underline">Settings → Messages</Link>.
      </p>
    </div>
  )
}
